<div class="icard">
  <p class="user"><mat-icon>person</mat-icon> {{ record.user.fullname }}</p>
  <p class="textAction" [id]="record.action">{{ record.action }}</p>
  <button
    *ngIf="record.action.length > 50"
    (click)="toggleText()"
    class="boton"
    [id]="record._id"
  >
    Leer más
  </button>
  <p class="date">{{ date | date : "d/MM/yyyy h:mm a" }}</p>
</div>
